import { between } from './number';

const isDry = (temperature_control_class) => temperature_control_class === 'DRY';

export const mandatoryThermograph = ['RRC', 'FRC', 'FRF'];

export const reorderMinAndMax = ({ min, max }) => {
  return {
    min: Number(max) < Number(min) ? max : min,
    max: Number(min) > Number(max) ? min : max,
  };
};

export const serializeVehicleTemperature = (temperature_control_class) => {
  const [type, isolation, _class] = [...(temperature_control_class || ['?', '?', '?'])];

  return {
    temperature_details: {
      type: isDry(temperature_control_class) ? temperature_control_class : type,
      isolation: isDry(temperature_control_class) ? '?' : isolation,
      _class: isDry(temperature_control_class) ? '?' : _class,
    },
  };
};

export const deserializeVehicleTemperature = (
  vehicle_type,
  { type = '?', isolation = '?', _class = '?' }
) => {
  if (vehicle_type === 'tractor_unit') {
    return {
      temperature_control_class: 'DRY',
    };
  }
  return {
    temperature_control_class: isDry(type)
      ? type
      : `${type ? type : '?'}${isolation ? isolation : '?'}${
          type !== 'I' ? (_class ? _class : '?') : ''
        }`,
  };
};

export const vehicleTemperatureMap = {
  R: {
    N: {
      A: { min: 7, max: 12 },
      D: { min: 0, max: 12 },
    },
    R: {
      A: { min: 7, max: 12 },
      B: { min: -10, max: 12 },
      C: { min: -20, max: 12 },
      D: { min: 0, max: 12 },
    },
  },
  F: {
    N: {
      A: { min: 0, max: 28 },
      D: { min: 0, max: 28 },
    },
    R: {
      A: { min: 0, max: 28 },
      B: { min: -10, max: 28 },
      C: { min: -20, max: 28 },
      D: { min: 0, max: 28 },
      E: { min: -10, max: 28 },
      F: { min: -20, max: 28 },
    },
  },
  C: {
    N: {
      A: {},
    },
    R: {
      A: {},
      B: {},
    },
  },
  I: {
    N: {},
    R: {},
  },
};

export const getTemperatureRange = (vehicle) => {
  const { type, isolation, _class } = vehicle.temperature_details || {};

  if (
    !vehicleTemperatureMap[type] ||
    !vehicleTemperatureMap[type][isolation] ||
    !vehicleTemperatureMap[type][isolation][_class]
  ) {
    return null;
  }

  return vehicleTemperatureMap[type][isolation][_class];
};

export const isValidVehicleForTemperature =
  (vehicle) =>
  ({ min, max }, reverse = false) => {
    const allowedTemperature = getTemperatureRange(vehicle);

    if (!allowedTemperature) {
      return false;
    }

    return reverse
      ? between(allowedTemperature.min, { min, max }) ||
          between(allowedTemperature.max, { min, max })
      : allowedTemperature.min <= min && allowedTemperature.max >= max;
  };

export const cooledTemperature = { min: 0, max: 28 };
export const frozenTemperature = { min: -28, max: -1 };
